import { FC, Suspense, lazy } from 'react';
import { useIntl } from 'react-intl';
import { Button, Avatar, Dropdown, Menu } from 'antd';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';

import { useFelaEnhanced } from 'hooks';
import { Logo, Loader } from 'modules/ui';
import { Icon, IconType } from 'modules/ui';
import NavItem from 'modules/application/components/NavItem';

import config from 'config';
import { useGuestAuth } from '../../GuestAuthContext';

const BasicLayout = lazy(() => import('@ant-design/pro-layout').then(({ BasicLayout }) => ({ default: BasicLayout })));

const GuestLayout: FC = ({ children }) => {
    const { formatMessage } = useIntl();
    const { customer, logoutGuest } = useGuestAuth();

    const menuItems = [
        {
            name: formatMessage({ id: 'page.documents.title' }),
            path: config.routes.guestDocuments,
            icon: <Icon type={IconType.DOCUMENT} />,
            key: config.routes.guestDocuments,
        },
    ];

    const userMenu = (
        <Menu>
            <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={logoutGuest}>
                {formatMessage({ id: 'auth.logout' })}
            </Menu.Item>
        </Menu>
    );

    return (
        <Suspense fallback={<Loader show />}>
            <BasicLayout
                logo={<Logo />}
                title={null}
                navTheme="light"
                route={{ routes: menuItems }}
                menuItemRender={(props, item) => <NavItem to={props.path}>{item}</NavItem>}
                rightContentRender={() => (
                    <Dropdown overlay={userMenu} trigger={['click']}>
                        <Button type="text">
                            <Avatar icon={<UserOutlined />} size={32} />
                            <span style={{ marginLeft: 8 }}>{customer?.email ?? ''}</span>
                        </Button>
                    </Dropdown>
                )}
            >
                {children}
            </BasicLayout>
        </Suspense>
    );
};

export default GuestLayout;
